module.exports = __webpack_public_path__ + "media/assets/HWE_motivation_experience-13ce61295cad483cf90f98a7b107abe7.jpg";